// extracted by mini-css-extract-plugin
export default {"resetPassword":"reset-password_resetPassword__SlzXu","eye":"reset-password_eye__caaLg","opaque":"reset-password_opaque__YD4UE","button":"reset-password_button__DxTM4"};